import RepertoriAddModal from "./RepertoriAddModal.jsx";
export default RepertoriAddModal;
